import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Instagram, Music2, Youtube, ExternalLink, ArrowUpRight, Clapperboard } from "lucide-react";
import { useLang } from "../i18n";
import { socials } from "../data/safety";
import { api, API } from "../lib/api";

const iconMap = { Instagram, Music2, Youtube };

const posts = [
  { id: 1, tagDe: "Meilenstein", tagEn: "Milestone", de: "Magic Popcorn PM – gekört & Hengstleistungsprüfung erfolgreich bestanden.", en: "Magic Popcorn PM – licensed & stallion performance test passed." },
  { id: 2, tagDe: "Safety", tagEn: "Safety", de: "Warum ich vor jedem Ritt eine Checkliste nutze – Cockpit-Prinzip im Stall.", en: "Why I use a checklist before every ride – the cockpit principle in the stable." },
  { id: 3, tagDe: "Ponyliebe", tagEn: "Pony love", de: "Shetty Hanni & die nächste Generation. Sicherheit beginnt im Kleinen.", en: "Shetty Hanni & the next generation. Safety starts small." },
  { id: 4, tagDe: "Gelände", tagEn: "Trail", de: "Ausritt im Wald – Umfeld einschätzen, Notfallkontakt griffbereit.", en: "Trail ride in the forest – assess the environment, emergency contact ready." },
];

export default function Feed() {
  const { t, lang } = useLang();
  const [videos, setVideos] = useState([]);
  useEffect(() => {
    api.get("/videos").then((r) => setVideos(r.data)).catch(() => {});
  }, []);
  return (
    <div className="mx-auto max-w-5xl px-4 py-10 md:py-16">
      <h1 className="font-serif text-4xl md:text-5xl tracking-tight">{t.feed.title}</h1>
      <p className="mt-4 text-wachs-dim max-w-2xl">{t.feed.sub}</p>

      {videos.length > 0 && (
        <section className="mt-8">
          <div className="flex items-center gap-2 text-sonne"><Clapperboard size={18} /><h2 className="font-serif text-2xl">{lang === "de" ? "Bewegte Bilder" : "In motion"}</h2></div>
          <div className="mt-4 grid gap-4 grid-cols-2 md:grid-cols-3">
            {videos.map((v) => (
              <div key={v.id} data-testid={`feed-video-${v.id}`} className="relative rounded-lg overflow-hidden border border-bronze/15 aspect-square">
                <video src={`${API}/videos/${v.id}/file`} autoPlay muted loop playsInline className="w-full h-full object-cover" />
                {v.horse && <span className="absolute bottom-2 left-2 instrument-label text-wachs bg-nacht/60 rounded px-2 py-0.5">{v.horse}</span>}
              </div>
            ))}
          </div>
        </section>
      )}

      {/* Socials */}
      <div className="mt-8 grid gap-3 sm:grid-cols-3">
        {socials.map((s) => {
          const Icon = iconMap[s.icon];
          return (
            <a
              key={s.id}
              href={s.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`social-${s.id}`}
              className="group grid-panel rounded-lg p-5 flex items-center justify-between hover:border-sonne/50 transition-colors"
            >
              <div className="flex items-center gap-3">
                <Icon size={22} className="text-sonne" />
                <div>
                  <p className="text-sm text-wachs">{s.label}</p>
                  <p className="font-mono text-xs text-wachs-dim">{s.handle}</p>
                </div>
              </div>
              <ArrowUpRight size={18} className="text-wachs-dim group-hover:text-sonne group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
            </a>
          );
        })}
      </div>

      {/* Feed */}
      <div className="mt-10 grid gap-4 md:grid-cols-2">
        {posts.map((p, i) => (
          <motion.article
            key={p.id}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.06 }}
            data-testid={`feed-post-${p.id}`}
            className="grid-panel rounded-lg p-6 hover:border-bronze/40 transition-colors"
          >
            <span className="instrument-label text-sonne">{lang === "de" ? p.tagDe : p.tagEn}</span>
            <p className="mt-3 font-serif text-xl leading-snug">{lang === "de" ? p.de : p.en}</p>
            <a href={socials[0].url} target="_blank" rel="noopener noreferrer" className="mt-4 inline-flex items-center gap-1.5 text-sm text-wachs-dim hover:text-sonne transition-colors">
              {t.feed.follow} <ExternalLink size={13} />
            </a>
          </motion.article>
        ))}
      </div>
    </div>
  );
}
